<div id="dragDiv"
     #draggableDiv
     class="draggable resize overlay-borde-campo"
     [ngStyle]="boxStyle">
      <svg #draggableIcon class="icon-draggable">
        <use #draggableUse xlink:href="#icon-draggable"></use>
      </svg>
      <svg *ngIf="!modoEnvioSimple" class="icon-editar" (click)="editarCampoEditable()">
        <use xlink:href="#hs-edit-key"></use>
      </svg>
      <svg class="icon-close" (click)="borrarCampoEditable()">
        <use xlink:href="#icon-close"></use>
      </svg>
     <div id="resizeDiv" class="pinta"></div>
</div>
